/**
 * AppShell — main layout wrapper for authenticated Inbox pages.
 *
 * Provides the Header, main content area, and Footer on every page.
 * Uses Framer Motion for smooth page transitions.
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './Header';
import Footer from './Footer';
import NoteCatchUpGate from '../shared/NoteCatchUpGate';

export default function AppShell() {
  return (
    <div style={styles.shell}>
      <Header />
      <main className="app-content" style={styles.main}>
        <AnimatePresence mode="wait">
          <motion.div
            key={window.location.pathname}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.25, ease: [0.4, 0, 0.2, 1] }}
            style={styles.content}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </main>
      <Footer />
      {/* Login catch-up gate (CLAUDE.md §31.9) — full-screen overlay when the
          active role has unacknowledged notes. Mounted here so it gates every
          protected route, after the role is resolved (AppShell only renders
          past RoleChooser). */}
      <NoteCatchUpGate />
    </div>
  );
}

const styles = {
  shell: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  main: {
    flex: 1,
    padding: '1.5rem',
    maxWidth: '1400px',
    width: '100%',
    margin: '0 auto',
  },
  content: {
    width: '100%',
  },
};
